import apiRequest from './client';

const toQuery = (params) => {
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  return qs ? `?${qs}` : '';
};

export const searchVerifyTickets = ({ filterType, scopeId, date, tirageFrom, tirageUp, ticket, docType }) =>
  apiRequest(
    `/tickets/verify/search/${toQuery({
      filter_type: filterType, scope_id: scopeId, date, tirage_from: tirageFrom, tirage_up: tirageUp, ticket,
      search_by: docType,
    })}`
  );
